var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, cn } from '../../utils/cn';
var cls = classNames('entity-list');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityRow } from './entity-row';
import { get } from 'lodash';
export var EntityListDefaultProps = {
  items: [],
  namePath: 'name',
  padFirst: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%; \n  "], ["\n    box-sizing: border-box;\n    width: 100%; \n  "])))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  "], ["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n    \n    ", "\n\n    ", "\n\n    ", "\n      \n    \n    ", "\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n    \n    ", "\n\n    ", "\n\n    ", "\n      \n    \n    ", "\n  "])), theme.UNIT(4), function (props) {
    return !props.showDividerForLast && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:last-child {\n        background: none;\n      }\n    "], ["\n      &:last-child {\n        background: none;\n      }\n    "])));
  }, function (props) {
    return props.showDividers && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme.H_DOT_BG_END('line-mid'), theme.UNIT(4), theme.UNIT(4, 2));
  }, function (props) {
    return !props.padFirst && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      &:first-child {\n        padding-top: 0;\n      }\n    "], ["\n      &:first-child {\n        padding-top: 0;\n      }\n    "])));
  }, function (props) {
    return props.useLinks && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      &:hover {\n        color: ", ";\n        .", " {\n          outline: 1px solid ", ";\n        }\n      }\n    "], ["\n      &:hover {\n        color: ", ";\n        .", " {\n          outline: 1px solid ", ";\n        }\n      }\n    "])), theme.COLOR('primary'), cn('entity-bubble-image'), theme.COLOR('primary'));
  })
});
var RowStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.ul.attrs(cls.attr('items'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Row: styled(EntityRow)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), RowStyles)
};
export var EntityList = function EntityList(props) {
  var className = props.className,
      _a = props.items,
      items = _a === void 0 ? [] : _a,
      onItemClick = props.onItemClick,
      namePath = props.namePath,
      padFirst = props.padFirst,
      showDividerForLast = props.showDividerForLast,
      rowProps = __rest(props, ["className", "items", "onItemClick", "namePath", "padFirst", "showDividerForLast"]);

  var showDividers = props.showDividers === undefined ? props.showDescription : props.showDividers;
  var RowComponent = props.rowComponent || My.Row;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Items, null, items.map(function (entity) {
    var name = get(entity, namePath, '');
    return React.createElement(My.Item, {
      padFirst: padFirst,
      useLinks: rowProps.useLinks,
      showDividerForLast: showDividerForLast,
      showDividers: showDividers,
      onClick: onItemClick,
      key: entity.id
    }, React.createElement(RowComponent, __assign({
      entity: entity,
      name: name
    }, rowProps)));
  })));
};
EntityList.defaultProps = EntityListDefaultProps;
EntityList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;